import { jwtDecode } from 'jwt-decode';

export default class JWT {
  #token;

  setToken(token) {
    this.#token = token;
  }

  getToken() {
    return this.#token;
  }

  /**
   * Check if the token is valid
   * @returns {boolean}
   */
  isValid() {
    try {
      const { exp } = jwtDecode(this.#token);
      const currentTime = Date.now() / 1000;

      return exp > currentTime;
    } catch (error) {
      return false;
    }
  }

  /**
   * Check if the token is expired
   * @returns {boolean}
   */
  isExpired() {
    try {
      const { exp } = jwtDecode(this.#token);
      const currentTime = Date.now() / 1000;

      return exp < currentTime;
    } catch (error) {
      return true;
    }
  }

  /**
   * Check if the token will expire soon
   * @param {number} bufferTime - default 2 minutes
   * @returns {boolean}
   */
  itWillExpireSoon(bufferTime = 120_000) {
    try {
      const { exp } = jwtDecode(this.#token);
      const currentTime = Date.now() / 1000;

      return exp < currentTime + (bufferTime / 1000);
    } catch (error) {
      return false;
    }
  }

  /**
   * Total lifetime this token was issued for, in milliseconds, or null when it cannot be
   * determined. Read from the token's own iat/exp rather than assumed, because the server
   * lifetime is configurable per environment (SystemSettings SessionTokenLifetimeMinutes)
   * and a caller that hardcodes 4 hours would renew continuously on a short-lived token.
   * @returns {number|null}
   */
  getLifetime() {
    try {
      const { exp, iat } = jwtDecode(this.#token);

      if (typeof exp !== 'number' || typeof iat !== 'number') return null;

      const lifetime = (exp - iat) * 1000;

      return lifetime > 0 ? lifetime : null;
    } catch (error) {
      return null;
    }
  }
}
